import { BaseNodeConfig } from 'dto/NodeConfig';

export class FlowConfig {

    FlowId: string;
    Name: string;
    Nodes: BaseNodeConfig[];
    RootNode: BaseNodeConfig;
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/FlowConfig.ts